/* eslint-disable max-len */

import { fireAuth } from '../../database/utils/firebase';
import { actionStruct } from '../utils';

const Types = {
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  UDPATE_USER_DATA: 'GET_USER_INFO',
  SET_USER_PHOTO_URL: 'SET_USER_PHOTO_URL'
};

const LoggedInTypes = {
  IsAuthenticated: 1,
  NotAuthenticated: 0
};

const INITIAL_VALUE = {
  uid: null,
  user_email: null,
  user_data: null,
  user_photo_url: null,
  user_logged_in: LoggedInTypes.NotAuthenticated
};

export const logIn = (userID, userEmail, userData) =>
  actionStruct(Types.LOG_IN, {
    uid: userID,
    user_email: userEmail,
    user_data: userData
  });

export const logOut = () => {
  fireAuth.signOut();
  return actionStruct(Types.LOG_OUT);
};

export const updateUserData = (userData) => actionStruct(Types.UDPATE_USER_DATA, userData);
export const setUserPhotoURL = (userPhotoURL) =>
  actionStruct(Types.SET_USER_PHOTO_URL, userPhotoURL);

export const reducer = (state = INITIAL_VALUE, action) => {
  switch (action.type) {
    case Types.LOG_IN:
      return { ...action.payload, user_logged_in: LoggedInTypes.IsAuthenticated };

    case Types.LOG_OUT:
      return INITIAL_VALUE;

    case Types.UDPATE_USER_DATA:
      return { ...state, user_data: action.payload };

    case Types.SET_USER_PHOTO_URL:
      return { ...state, user_photo_url: action.payload };

    default:
      return state;
  }
};
